





















































































































































// import { defineComponent } from '@vue/composition-api'
import { Component, Vue, Watch, Provide } from "vue-property-decorator";
const qualityPounts = () => import("./commpon/qualityPoints.vue");
import {
  ticketClient,
  authorClient,
  client,
  collectionServiceClient,
} from "@/api/index";
import {
  GetAudioQualityRuleListReq,
  Bool,
  OpenTicketReq,
  AudioQualityRuleData,
  SaveAudioQualityRuleReq,
  GetAudioQualityOptionReq,
  GetAudioQualityScriptListReq,
  AudioQualityScriptData,
  GetAudioQualityRuleReq,
  QualityPoint,
  ScriptPoint,
  RepeatScript,
} from "@/pbjs/external/ticket/ticket_pb";
import {
  ListUserGroupByTypeReq,
  ListUserGroupByMutiTypeReq,
} from "@/pbjs/external/auth/auth_pb";
import { ExecType } from "@/pbjs/xcommon/enum_pb";
import { timeFormat, downloadFile, setValue } from "@/utils/index";
import {
  SearchUserReq,
  BatchGetLoginInfoReq,
  GetOutSourceInfoReq,
} from "@/pbjs/external/user/user_pb";
import { pagnition } from "@/utils/commonConfig";
import { setCommon, handleResponse, setPage, errorMsg } from "@/utils/request";
import { Sort, Rank } from "@/pbjs/xcommon/common_pb";
@Component({
  name: "addNewRules",
  components: {
    qualityPounts,
  },
})
export default class CombinationProperty extends Vue {
  @Provide() private isShowSearchRegion: boolean = true;
  @Provide() private Scoring: any = "";
  @Provide() private numberofmatches: any = "";
  @Provide() private isSaveAudioQualityRuleLoding: boolean = false;
  @Provide() private num: any = "";
  @Provide() private teleOptions: any = [];
  @Provide() private nxteleOptions: any = [];
  @Provide() private nxteleOptionsPoint: any = [];
  @Provide() private QCPointTypeList: any = [];
  @Provide() private qualityobjectmapMap: any = [];
  @Provide() private ScoringOptions: any = [];
  @Provide() private resultOptions: any = "";
  @Provide() private addNewList: any = [
    {
      index: 1,
      object: null,
      qualitytype: null,
      repeatscript: null,
      scriptpoint: null,
    },
  ];
  @Provide() private radio: any = "2";
  @Provide() private ruleId: number = 0;
  @Provide() private userForm: any = {
    RulesDescription: null,
    ruleName: null,
    score: null,
  };
  private created() {
    if (this.$route.query.id) {
      this.GetAudioQualityRuleReq(this.$route.query.id);
      this.AudioQualityOptionReq();
      this.getTicketList();
    } else {
      this.AudioQualityOptionReq();
      this.getTicketList();
    }
  }
  private async getTicketList() {
    let request: any = new GetAudioQualityScriptListReq();
    request.setCommonin(setCommon());
    request.setPagein(setPage(0, 999));
    let requestAuto: any = new AudioQualityScriptData();
    requestAuto.setId();
    requestAuto.setScriptname();
    requestAuto.addScripttext();
    requestAuto.setScriptnum();
    requestAuto.setUid();
    requestAuto.setUsername();
    requestAuto.setCtime();
    requestAuto.setStatus();
    request.setData(requestAuto);
    await ticketClient.getAudioQualityScriptList(
      request,
      {},
      (err: any, response: any) => {
        if (response) {
          let data: any = response.toObject();
          let _fuc = this.getscriptnameListAPIFuc;
          handleResponse(data, _fuc);
        }
        if (err) {

          errorMsg(err);
        }
      }
    );
  }
  private getscriptnameListAPIFuc(data: any) {
    data.listList.forEach((item: any, index: any) => {
      if (item.status == 1) {
        this.nxteleOptionsPoint.push({ 0: item.id, 1: item.scriptname });
      }
    });
  }
  private addQCpoint() {
    this.addNewList.push({ index: this.addNewList.length + 1 });
  }
  private getMyEvent(msg: any) {
    this.addNewList.splice(msg - 1, 1);
  }
  private selectRole() {}
  private getRuleReqAPIFuc(data: any) {
    this.ruleId = data.data.id; //规则id
    this.userForm.ruleName = data.data.rulename;
    this.userForm.RulesDescription = data.data.ruletext;
    this.Scoring = data.data.scorepolicy;
    this.userForm.score = data.data.score;
    // data.data.scorepolicy == 1
    //   ? "+" + data.data.score
    //   : "-" + data.data.score;
    this.numberofmatches = data.data.matchtimes;
    this.radio = data.data.logical + "";
    this.addNewList = data.data.qualitypointlistList;
    setTimeout(() => {
      this.addNewList.forEach((item: any, index: number) => {
        item.index = index + 1;
        let aa = this.$refs[`qualityPounts${index}`];
        (aa as any)[0].getruleDataFuc(item);
      });
    }, 300);
  }
  //获取反显详情
  private async GetAudioQualityRuleReq(id: any) {
    let request = new GetAudioQualityRuleReq();
    request.setCommonin(setCommon());
    request.setPagein(setPage(0, 0));
    request.setId(Number(id));
    await ticketClient.getAudioQualityRule(
      request,
      {},
      (err: any, response: any) => {
        if (response) {
          let data: any = response.toObject();
          let _fuc = this.getRuleReqAPIFuc;
          handleResponse(data, _fuc);
        }
        if (err) {

          errorMsg(err);
        }
      }
    );
  }
  private getRoleListAPIFuc(data: any) {
    this.ScoringOptions = data.scorepolicymapMap;
    this.nxteleOptions = data.matchtimesmapMap;
    // this.resultOptions=data
    this.QCPointTypeList = data.qualitytypemapMap;
    this.teleOptions = data.hitrulemapMap;
    this.qualityobjectmapMap = data.qualityobjectmapMap;
  }
  //获取下拉列表
  private AudioQualityOptionReq() {
    let request = new GetAudioQualityOptionReq();
    request.setCommonin(setCommon());
    ticketClient.getAudioQualityOption(
      request,
      {},
      (err: any, response: any) => {
        if (response) {
          let data: any = response.toObject();
          let _fuc = this.getRoleListAPIFuc;
          handleResponse(data, _fuc);
        }
        if (err) {

          errorMsg(err);
        }
      }
    );
  }
  private testSaveAudioQualityRule() {
    this.addNewList.forEach((item: any, index: number) => {
      item.index = index + 1;
      let aa = this.$refs[`qualityPounts${index}`];
      item.qualitytype = Number((aa as any)[0].QCPointType);
      item.object = (aa as any)[0].QCobject;
      // item.repeatscript={}
      (item.scriptpoint as any) = {};
      (item.repeatscript as any) = {};
      item.repeatscript.continuity = (aa as any)[0].userForm.Within;
      item.repeatscript.repeat = (aa as any)[0].userForm.Repeat;
      item.scriptpoint.hitrule = (aa as any)[0].SpellPointHitRules;
      (item.scriptpoint.data as any) = {};
      item.scriptpoint.data.id = (aa as any)[0].Scoring;
    });
    if (
      this.userForm.ruleName &&
      this.Scoring &&
      this.userForm.score &&
      this.numberofmatches &&
      this.radio &&
      this.addNewList.length > 0
    ) {
      let a: any[] = [];
      this.addNewList.forEach((item: any, index: any) => {
        if (item.qualitytype && item.qualitytype == 1) {
          if (
            item.object &&
            item.repeatscript.repeat &&
            item.repeatscript.continuity
          ) {
            return a.push({ index: true });
          } else {
            return a.push({ index: false });
          }
        } else if (item.qualitytype && item.qualitytype == 2) {
          if (
            item.object &&
            item.scriptpoint.data.id &&
            typeof item.scriptpoint.data.id == "number"
          ) {
            return a.push({ index: true });
          } else {
            return a.push({ index: false });
          }
        } else {
          return a.push({ index: false });
        }
      });
      if (a.findIndex((index: any) => index.index === false) === -1) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }
  //保存
  private SaveAudioQualityRule() {
    this.isSaveAudioQualityRuleLoding = true;
    if (this.testSaveAudioQualityRule()) {
      let request = new SaveAudioQualityRuleReq();
      request.setCommonin(setCommon());
      request.setId(Number(this.$route.query.id));
      let requestAuto = new AudioQualityRuleData();
      requestAuto.setId(Number(this.ruleId)); // 规则ID
      requestAuto.setRulename(this.userForm.ruleName); // 规则名称
      requestAuto.setRuletext(this.userForm.RulesDescription); // 规则描述说明
      requestAuto.setScorepolicy(this.Scoring); // 评分方法 加分/减分
      requestAuto.setScore(this.userForm.score); // 分值
      requestAuto.setPointnum(this.addNewList.length); // 质检点数量
      let arr: any[] = [];
      this.addNewList.forEach((item: any, index: any) => {
        let requestThree = new QualityPoint(); // QualityPoint
        requestThree.setId(item.id ? item.id : item.index); // 质检点序号
        requestThree.setName(item.name); // 质检点名称
        requestThree.setObject(item.object); // 质检对象
        requestThree.setQualitytype(item.qualitytype); // 质检类型 重复话术/话术点/静默时长/抢话
        let requestFour = new RepeatScript(); // 重复话术
        requestFour.setContinuity(
          Number(item.repeatscript ? item.repeatscript.continuity : "")
        ); // 连续次数
        requestFour.setRepeat(
          Number(item.repeatscript ? item.repeatscript.repeat : "")
        ); // 重复次数
        requestThree.setRepeatscript(requestFour);
        let requestFive = new ScriptPoint();
        requestFive.setHitrule(item.scriptpoint.hitrule); // 命中规则
        let requestSix = new AudioQualityScriptData(); // 话术点
        requestSix.setId(Number(item.scriptpoint.data.id)); // 话术ID
        requestSix.setScriptname(""); // 话术名称
        requestSix.setUid(Number()); // 创建人ID
        requestSix.setUsername(""); // 创建人姓名
        requestSix.setCtime(Number()); // 创建时间
        //  requestSix.setStatus()// 状态
        requestFive.setData(requestSix);
        requestThree.setScriptpoint(requestFive);
        arr.push(requestThree);
      });

      requestAuto.setQualitypointlistList(arr);
      requestAuto.setMatchtimes(Number(this.numberofmatches)); // 匹配次数
      requestAuto.setLogical(Number(this.radio)); // 逻辑关系 与/或
      //  requestAuto.setUid()// 创建人ID
      //  requestAuto.setUsername()// 创建人姓名
      //  requestAuto.setCtime()// 创建时间
      //  requestAuto.setStatus()// 状态
      request.setData(requestAuto);

      ticketClient.saveAudioQualityRule(
        request,
        {},
        (err: any, response: any) => {
          if (response) {
            let data: any = response.toObject();
            if (data.commonout.code == 0) {
              this.$message.success("success");
              this.isSaveAudioQualityRuleLoding = false;
            } else {
              this.isSaveAudioQualityRuleLoding = false;
              this.$message.error(data.commonout.errmsg);
            }
          }
          if (err) {
            this.isSaveAudioQualityRuleLoding = false;
            errorMsg(err);
          }
        }
      );
    } else {
      let bb: any = [];
      this.addNewList.forEach((item: any, index: any) => {
        if (typeof item.scriptpoint.data.id !== "number") {
          bb.push({ name: item.scriptpoint.data.id, em: false });
          // this.$message.error(`${item.scriptpoint.data.id} invalid`);
        } else {
          bb.push({ name: item.scriptpoint.data.id, em: true });
        }
        // else {
        //   // this.$message({
        //   //   type: "error",
        //   //   message: "pls check the form value!",
        //   // });
        // }
      });
      if (bb.findIndex((item: any) => item.em === false) === -1) {
        this.$message({
          type: "error",
          message: "pls check the form value!",
        });
      } else {
        bb.forEach((item: any) => {
          if (typeof item.name !== "number") {
            this.$message.error(`${item.name} invalid`);
          }
        });
      }
      this.isSaveAudioQualityRuleLoding = false;
    }
  }
}
